<script setup lang="ts">
import { InstantSearch } from 'instantsearch.js';
import get from 'lodash/get';
import { onUnmounted } from 'vue';
// @ts-expect-error (function lacks types; this should be converted in the near future)
import { AisConfigure, AisHits, AisInstantSearch } from 'vue-instantsearch/vue3/es';

import Header6 from '@/components/base/typography/Header6.vue';
import ResultCard from '@/components/search/departments/ResultCard.vue';
import ResultLink from '@/components/search/departments/ResultLink.vue';

defineProps<{
  query?: string;
  searchClient: InstantSearch['client'];
  userToken?: string;
}>();

const emit = defineEmits({
  'departments-update': (_: boolean) => true,
});

const hasSuggestions = (instantSearchInstance: InstantSearch) => {
  const nbHitsKey = 'helper.lastResults.nbHits';
  emit('departments-update', get(instantSearchInstance, nbHitsKey, 0) > 0);
};

const middlewares = [
  ({ instantSearchInstance }: { instantSearchInstance: InstantSearch }) => {
    instantSearchInstance.on('render', () => {
      hasSuggestions(instantSearchInstance);
    });
    return {
      unsubscribe: () => hasSuggestions(instantSearchInstance),
    };
  },
];

const analyticsTags = ['Search'];

onUnmounted(() => {
  emit('departments-update', false);
});
</script>

<template>
  <AisInstantSearch
    v-if="query && query.length >= 3"
    class="department-suggestions"
    data-test="department-suggestions"
    index-name="Departments"
    :middlewares
    :search-client="searchClient"
  >
    <AisConfigure
      :analyticsTags
      distinct
      filters="idealForSuggestions:true"
      :hitsPerPage="4"
      :query
      :userToken
    />
    <AisHits>
      <template v-slot:default="{ items }">
        <div v-if="items.length" class="md:pb-5">
          <div class="mb-6">
            <div class="hidden md:visible md:inline md:w-full">
              <Header6>Popular Departments</Header6>
              <div class="flex gap-2">
                <ResultCard
                  v-for="department in items"
                  :key="department.objectID"
                  data-test="department-search-hit-card"
                  :department
                />
              </div>
            </div>
            <div class="md:hidden" data-test="search-suggestions-mobile">
              <span v-if="items.length" class="department-search-suggestions"> Suggestions: </span>
              <ResultLink v-for="(department, i) in items" :key="department.objectID" :department>
                <template v-if="i + 1 < items.length">,</template>
              </ResultLink>
            </div>
          </div>
        </div>
      </template>
    </AisHits>
  </AisInstantSearch>
</template>
